// Утилиты для работы с изображениями
export const imageUtils = {
  // Сохранение изображения в localStorage (для демонстрации)
  saveImageToStorage: (imageData, filename) => {
    try {
      const images = JSON.parse(localStorage.getItem('uploaded_images') || '{}');
      images[filename] = imageData;
      localStorage.setItem('uploaded_images', JSON.stringify(images));
      return `/api/images/${filename}`; // Возвращаем URL для отображения
    } catch (error) {
      console.error('Ошибка при сохранении изображения:', error);
      return null;
    }
  },

  // Получение изображения из localStorage
  getImageFromStorage: (filename) => {
    try {
      const images = JSON.parse(localStorage.getItem('uploaded_images') || '{}');
      return images[filename] || null;
    } catch (error) {
      console.error('Ошибка при получении изображения:', error);
      return null;
    }
  },

  // Генерация уникального имени файла
  generateFilename: (originalName) => {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substring(2, 8);
    const extension = originalName.split('.').pop();
    return `blog_${timestamp}_${random}.${extension}`;
  },

  // Сжатие изображения
  compressImage: (file, maxWidth = 800, quality = 0.8) => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        // Вычисляем новые размеры
        let { width, height } = img;
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;

        // Рисуем сжатое изображение
        ctx.drawImage(img, 0, 0, width, height);

        // Конвертируем в blob
        canvas.toBlob(resolve, 'image/jpeg', quality);
      };

      img.src = URL.createObjectURL(file);
    });
  },

  // Валидация изображения
  validateImage: (file) => {
    const errors = [];

    // Проверка типа файла
    if (!file.type.startsWith('image/')) {
      errors.push('Файл должен быть изображением');
    }

    // Проверка размера (максимум 5MB)
    if (file.size > 5 * 1024 * 1024) {
      errors.push('Размер файла не должен превышать 5MB');
    }

    // Проверка формата
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      errors.push('Поддерживаются только форматы: JPEG, PNG, GIF, WebP');
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  },

  // Получение всех загруженных изображений
  getAllImages: () => {
    try {
      const images = JSON.parse(localStorage.getItem('uploaded_images') || '{}');
      return Object.keys(images).map(filename => ({
        filename,
        url: `/api/images/${filename}`,
        data: images[filename]
      }));
    } catch (error) {
      console.error('Ошибка при получении изображений:', error);
      return [];
    }
  },

  // Удаление изображения
  deleteImage: (filename) => {
    try {
      const images = JSON.parse(localStorage.getItem('uploaded_images') || '{}');
      delete images[filename];
      localStorage.setItem('uploaded_images', JSON.stringify(images));
      return true;
    } catch (error) {
      console.error('Ошибка при удалении изображения:', error);
      return false;
    }
  }
};
